module.exports = __webpack_public_path__ + "img/17422562000126.7afc955d.png";